import api from './api';

export const authService = {
  login: async (email, password) => {
    console.log('🔐 [AUTH] Intentando login con:', email);
    
    // Usar URLSearchParams para enviar como application/x-www-form-urlencoded
    const formData = new URLSearchParams();
    formData.append('username', email);
    formData.append('password', password);
    
    console.log('📤 [AUTH] Enviando request a /auth/login');
    
    try {
      const response = await api.post('/auth/login', formData, {
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
      });
      
      console.log('✅ [AUTH] Login exitoso, obteniendo token');
      
      if (response.data.access_token) {
        localStorage.setItem('token', response.data.access_token);
        console.log('📝 [AUTH] Token guardado, obteniendo perfil de usuario');
        
        const user = await authService.getMe();
        console.log('👤 [AUTH] Usuario obtenido:', user);
        
        localStorage.setItem('user', JSON.stringify(user));
        return user;
      }
      return response.data;
    } catch (error) {
      console.error('❌ [AUTH] Error en login:', error);
      console.error('❌ [AUTH] Response:', error.response?.data);
      throw error;
    }
  },

  register: async (email, password, fullName, role = 'client') => {
    const response = await api.post('/auth/register', {
      email,
      password,
      full_name: fullName,
      role,
    });
    return response.data;
  },

  getMe: async () => {
    const response = await api.get('/auth/me');
    return response.data;
  },

  logout: () => {
    console.log('🚪 [AUTH] Cerrando sesión...');
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    localStorage.removeItem('clientTheme'); // Limpiar tema guardado
    console.log('✅ [AUTH] Sesión cerrada, localStorage limpio');
  },

  getCurrentUser: () => {
    const userStr = localStorage.getItem('user');
    return userStr ? JSON.parse(userStr) : null;
  },

  isAuthenticated: () => {
    return !!localStorage.getItem('token');
  },
};
